// If revenue is 10 or above, Payout = (Revenue - 60) *  0.109 + 15 but payout should never be greater than $75
export const calculatePayoutAmount = ({ commissionAmount }) => {
  if (commissionAmount < 10) {
    return 0;
  }

  const amount = (commissionAmount - 60) * 0.109 + 15;

  if (amount >= 75) {
    return 75;
  }

  // Round amount to the nearest lowest integer.
  return Math.floor(amount);
};
